import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'examOnline',
  getExamInfo (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/examineeInfo/${id}`)
  },
  editExam (data = {}) {
    return Ajax.put(`/api/gradeOrganization/v1/${this.model}/updateExam`, data)
  },
  getExamSubjectList (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listExamSubject/${id}`)
  },
  getSubjectGroupList (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listSubjectGroup/${id}`)
  },
  addExamSubject (data = {}) {
    return Ajax.post(`/api/gradeOrganization/v1/examImport/addExamSubject`, data)
  },
  editExamSubject (data = {}) {
    return Ajax.put(`/api/gradeOrganization/v1/${this.model}/updateExamSubject`, data)
  },
  refundExam (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/refundOrder/${id}`)
  },
  exportExcel (param) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportEnrollExam`, param)
  },
  getRefundExam (param) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageRefundExam`, param)
  },
  getMusicbasisPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/exam/page`, queryParam)
  },
  getBatchList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/batch/list`, queryParam)
  },
  getSpecialtyList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/specialty/list`, queryParam)
  },
  getGradeList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/grade/list`, queryParam)
  },
  ExamExportExcel (param) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/exam/export/${`3`}`, param)
  },
  exportTask (key) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/exam/lookExportTask/${key}`)
  },
  getMusicbasisResultPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/proxy/v1/evaluate/pageAgentEvaluateExam`, queryParam)
  }
}
